import { useIntl } from "react-intl";
import Seo from "../../components/Seo";
import Childhood from "../../containers/Childhood";

function Page() {
  const intl = useIntl();

  return (
    <>
      <Seo
        title={intl.formatMessage({ defaultMessage: "Enfance" })}
        description={intl.formatMessage({
          defaultMessage:
            "Découvrez nos services de garderie et les activités proposées aux enfants pour les mercredis et les vacances scolaires.",
        })}
      />

      <Childhood />
    </>
  );
}

export default Page;

/** @param {import("next").NextPageContext} context */
Page.getInitialProps = async function (context) {
  return {
    layout: "public",
  };
};
